import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import HelpIco from '@icons/ovb/help.svg';
import {
  Help,
  StyledPara,
  StyledParaHeader,
  Title,
  ModalMask,
  IconWrapper,
} from './styled';

export const useHelpPopup = () => {
  const [visible, setVisible] = useState(false);

  const openHelp = () => setVisible(true);
  const closeHelp = () => setVisible(false);

  const HelpIcon = () => (
    <IconWrapper onClick={openHelp}>
      <HelpIco />
    </IconWrapper>
  );

  return {
    helpContext: {
      openHelp,
      closeHelp,
      visible,
    },
    HelpIcon,
  };
};

export const HelpPopup = ({ title, helpText, helpContext }) => {
  const { closeHelp, visible } = helpContext;

  return <>
    {visible ? (
      <>
        <ModalMask onClick={closeHelp} />
        <Help>
          <StyledParaHeader>
            <Title>{title}</Title>
            <CloseOutlined onClick={closeHelp} />
          </StyledParaHeader>
          <StyledPara>
            {helpText}
          </StyledPara>
        </Help>
      </>
    ) : null}
  </>;
};
